import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

// Custom toggle — keeps the globe icon, no caret
const GlobeToggle = React.forwardRef(({ onClick }, ref) => (
  <a
    href="#"
    ref={ref}
    className="nav-link px-0"
    aria-label="Change language"
    onClick={(e) => { e.preventDefault(); onClick(e); }}
  >
    <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24" height="24"
      viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"
      strokeLinecap="round" strokeLinejoin="round">
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
      <path d="M3.6 9h16.8" />
      <path d="M3.6 15h16.8" />
      <path d="M11.5 3a17 17 0 0 0 0 18" />
      <path d="M12.5 3a17 17 0 0 1 0 18" />
    </svg>
  </a>
));
GlobeToggle.displayName = 'GlobeToggle';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
  };

  return (
    <div className="nav-item d-flex me-2">
      <Dropdown align="end">
        <Dropdown.Toggle as={GlobeToggle} />
        <Dropdown.Menu>
          <Dropdown.Item
            as="button"
            className={`d-flex align-items-center ${currentLanguage === 'cs' ? 'active' : ''}`}
            onClick={() => changeLanguage('cs')}
          >
            <span className="me-2">🇨🇿</span> Česky
          </Dropdown.Item>
          <Dropdown.Item
            as="button"
            className={`d-flex align-items-center ${currentLanguage === 'en' ? 'active' : ''}`}
            onClick={() => changeLanguage('en')}
          >
            <span className="me-2">🇬🇧</span> English
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default LanguageSwitcher;
